import { withStorage } from 'lib/prompts';
import { DEEP_LINK_PARAM, DEEP_LINK_STORAGE_KEY } from './constants';

/** Called once at start-up: keeps a ?whats-new= link until the app can open it, even through sign-in. */
export const rememberDeepLink = (search: string): void => {
  const id = new URLSearchParams(search).get(DEEP_LINK_PARAM);
  if (id) withStorage(undefined, () => sessionStorage.setItem(DEEP_LINK_STORAGE_KEY, id));
};

/** The link kept at start-up, if any; taking it forgets it. */
export const takeRememberedLink = (): string | null =>
  withStorage(null, () => {
    const id = sessionStorage.getItem(DEEP_LINK_STORAGE_KEY);
    sessionStorage.removeItem(DEEP_LINK_STORAGE_KEY);
    return id;
  });
